<template>
  <div class="general-data">
    <div class="columns view-desktop">
      <div class="column .is-9">
        <div class="register-container">
          <span>{{ this.$t('perfil.registro') }}</span>
          <h2>{{ paciente.Prontuario }}</h2>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-3 view-desktop">
        <select-image @isReady="isReady()" />
      </div>
      <div class="column is-9">
        <div class="view-mobile">
          <div class="columns">
            <div class="column">
              <div class="register-container">
                <span>{{ this.$t('perfil.registro') }}</span>
                <h2>{{ paciente.Prontuario }}</h2>
              </div>
            </div>
          </div>
        </div>
        <form @submit.prevent="atualizar" class="form-template">
          <div class="columns">
            <div class="column">
              <b-field :label="this.$t('perfil.nome')">
                <b-input v-model="paciente.Nome" disabled />
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <b-field
                :label="this.$t('perfil.nome-social-opcional')"
                :type="{ 'is-danger': errors.has('register') }"
                :message="errors.first('register')"
              >
                <b-input
                  v-model.lazy="paciente.NomeSocial"
                  name="socialName"
                  @input="isReady()"
                  disabled
                />
              </b-field>
            </div>
            <div class="column">
              <b-field :label="this.$t('perfil.data-nascimento')">
                <b-input v-model="birthdayFormatted" disabled />
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <b-field :label="this.$t('perfil.cpf')">
                <b-input
                  v-model="paciente.CPF"
                  v-mask="['###.###.###-##']"
                  disabled
                />
              </b-field>
            </div>
            <div class="column">
              <b-field :label="this.$t('perfil.rg')">
                <b-input v-model="paciente.RG" disabled />
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <b-field
                :label="this.$t('perfil.raca-cor')"
                :message="this.$t('perfil.aviso-raca-cor')"
              >
                <b-select
                  v-model.lazy="racaCorSelecionada"
                  :placeholder="dropdown"
                  @input="isReady()"
                  required
                >
                  <option
                    v-for="option in racacor"
                    :key="option.Codigo"
                    :value="option.Codigo"
                  >
                    {{ option.Descricao }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column">
              <b-field :label="this.$t('perfil.etnia')">
                <b-select
                  v-model.lazy="etniaSelecionada"
                  :placeholder="dropdown"
                  @input="isReady()"
                  :disabled="!habilitarEtnia"
                  :required="habilitarEtnia"
                >
                  <option
                    v-for="option in etnia"
                    :key="option.Codigo"
                    :value="option.Codigo"
                  >
                    {{ option.Descricao }}
                  </option>
                </b-select>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <b-field :label="this.$t('perfil.filiacao-1')">
                <b-input v-model="paciente.NomeMae" disabled />
              </b-field>
            </div>
            <div class="column">
              <b-field :label="this.$t('perfil.filiacao-2')">
                <b-input v-model="paciente.NomePai" disabled />
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column is-4 is-offset-8">
              <div class="field">
                <button
                  :disabled="disabledButton"
                  class="button button-primary"
                >
                  {{ this.$t('botoes.atualizar') }}
                </button>
              </div>
            </div>
          </div>
        </form>
        <b-loading :is-full-page="true" :active.sync="isLoading" />
        <modal-template v-if="showModal" class="override-modal">
          <template #header>
            <h2>{{ modalInfo.titulo }}</h2>
          </template>
          <template #body>
            <p>{{ modalInfo.subtitulo }}</p>
          </template>
          <template #footer>
            <button
              id="loginmodal"
              class="button button-primary"
              @click="modalInfo.acaoBotao"
            >
              {{ modalInfo.btnTexto }}
            </button>
          </template>
        </modal-template>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router'
import SelectImage from '@/components/personal-data/SelectImage'
import ModalTemplate from '@/components/shared/modal/ModalTemplate'
import {
  SET_PERFIS,
  SET_DADOS_PACIENTE,
  SET_LOADING
} from '@/store/modules/mutation-types'
import { mapMutations, mapGetters, mapActions } from 'vuex'
import { format, parseISO } from 'date-fns'
import { NotAuthenticatedError } from '../../models/not-authenticated-error'

export default {
  components: {
    ModalTemplate,
    SelectImage
  },

  data() {
    return {
      showModal: false,
      disabledButton: true,
      commonPlaceholder: this.$t('placeholders.common'),
      dropdown: this.$t('placeholders.dropdown'),
      labelRegistro: this.$t('labels.registro'),
      mandatory: this.$t('login.mandatory'),
      racaCorSelecionada: this.paciente.RacaCor,
      etniaSelecionada: this.paciente.Etnia,
      habilitarEtnia: false
    }
  },

  computed: {
    ...mapGetters({
      racacor: 'getRacaCor',
      etnia: 'getEtnias',
      isLoading: 'loadingAuth'
    }),
    birthdayFormatted() {
      return format(parseISO(this.paciente.DataNascimento), 'dd/MM/yyyy')
    }
  },

  props: {
    paciente: {
      type: Object,
      default: () => {}
    }
  },

  methods: {
    ...mapMutations([SET_PERFIS, SET_DADOS_PACIENTE, SET_LOADING]),
    ...mapActions(['atualizarDadosPessoais']),
    toggleInfoModal() {
      this.showModal = !this.showModal
    },
    isReady() {
      this.disabledButton = this.racaCorSelecionada === '0'
      this.habilitarEtnia = this.racaCorSelecionada === '5'
      if (!this.habilitarEtnia) {
        this.etniaSelecionada = null
      }
    },
    mostrarModal(titulo, subtitulo, textoBotao, acaoBotao) {
      this.modalInfo = {
        titulo: titulo,
        subtitulo: subtitulo,
        btnTexto: textoBotao,
        acaoBotao: acaoBotao
      }
      this.showModal = !this.showModal
    },
    errorText(titulo, mensagem) {
      this.mostrarModal(
        titulo,
        mensagem,
        this.$t('botoes.confirmar'),
        this.toggleInfoModal
      )
    },
    okTexto() {
      this.mostrarModal(
        this.$t('mensagens.sucesso'),
        this.$t('mensagens.dados-atualizados'),
        this.$t('botoes.confirmar'),
        this.toggleInfoModal
      )
    },
    async atualizar() {
      this.SET_LOADING(true)
      this.atualizarDadosPessoais({
        CodigoPessoa: this.paciente.Codigo,
        CodigoRacaCor: this.racaCorSelecionada,
        CodigoEtnia: this.etniaSelecionada
      })
        .then(() => {
          this.paciente.RacaCor = this.racaCorSelecionada
          this.paciente.Etnia = this.etniaSelecionada
          this.okTexto()
        })
        .catch((err) => {
          if (err instanceof NotAuthenticatedError) {
            router.push('/')
          } else {
            this.errorText(err.detail, err.errors[0])
          }
        })
        .finally(() => this.SET_LOADING(false))
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
.general-data {
  .register-container {
    max-width: 17.8125rem;
    width: 100%;
    border-radius: $border-radius;

    background-color: var(--gray-100);
    float: right;
    padding: 0.7rem 2.1875rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    h2 {
      display: inline;
      font-weight: 700;
      font-size: 1.125rem;
    }
    span {
      font-size: 0.875rem;
    }
  }
  .form-template {
    label {
      padding-bottom: 1rem;
    }
  }
}
.view-mobile {
  .register-container {
    max-width: 100%;
    margin: 0.5rem auto;
    margin-bottom: 2rem;
  }
  .collumns {
    .collumn {
      margin: 0.5rem auto;
      .avatar-container {
        .img-container {
          margin: 0.5rem auto;
        }
        text-align: center;
      }
    }
  }
}
</style>
